import React, { useEffect, useState } from "react";
import AsyncImage from "../AsyncImage/AsyncImage";

import female_profile from "../../Images/female_profile.png";
import male_profile from "../../Images/male_profile.png";
import { useTranslation } from "react-i18next";
import axios from "axios";
import API from "../Api/API";
import { enlargeImage } from "../EnlargeImage/EnlargeImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCross } from "@fortawesome/free-solid-svg-icons";
import { use } from "react";
import { handleErrorMessage } from "../ErrorMessages/ErrorMessages";
import { showNotification } from "../Notification/Notification";

const CoachSelectForm = ({ primaryColor, coach, setCoach}) => {
  const [coaches, setCoaches] = useState([]);
  const [selectedCoach, setSelectedCoach] = useState(null);

  const primaryColorText = {
    color: primaryColor,
  };

  const tableStyle = {
    borderColor: "lightgray",
    verticalAlign: "middle",
  };

  const primaryColorBg = {
    backgroundColor: primaryColor,
    borderColor: primaryColor,
  };

  const lighterBgColorStyle = {
    backgroundColor: "white",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: primaryColor,
  };

  const { t } = useTranslation(["coach"]);

  useEffect(() => {
    const getData = async () => {
      const coachesResponse = await fetchCoaches();
      coachesResponse.forEach(async (manager) => {
        if (manager.photoPath === null) {
          if (manager.sex === "FEMALE") manager.photoSrc = female_profile;
          else manager.photoSrc = male_profile;
        }
      });
      setCoaches(coachesResponse);
    };
    getData();
  }, []);

  useEffect(() => {
    if (coach) {
      setSelectedCoach(coach);
    }
  }, [coach]);

  const fetchCoaches = () => {
    return axios
      .get(API.url + "api/club/all-coaches", {
        withCredentials: true,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleErrorMessage(err.response.status);
      });
  };

  const selectCoach = (e, coach) => {
    e.preventDefault();
    if (selectedCoach) {
      axios
        .post(
          API.url + "api/squad/leave/" + selectedCoach.squadId,
          {},
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          axios
            .post(
              API.url + "api/squad/join/" + coach.squadId,
              {},
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              showNotification(t("coach_changed"));
              setCoach(coach);
              setSelectedCoach(coach);
              document.getElementById("coach_select_form").style.display =
                "none";
              document.getElementById("coach_contact_form").style.display =
                "block";
            })
            .catch((err) => {
              handleErrorMessage(err.response.status);
            });
        })
        .catch((err) => {
          handleErrorMessage(err.response.status);
        });
    } else {
      axios
        .post(
          API.url + "api/squad/join/" + coach.squadId,
          {},
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          showNotification(t("coach_selected"));
          setCoach(coach);
          setSelectedCoach(coach);
          document.getElementById("coach_select_form").style.display = "none";
          document.getElementById("coach_contact_form").style.display = "block";
        })
        .catch((err) => {
          handleErrorMessage(err.response.status);
        });
    }
  };

  return (
    <div id="coach_select_form" style={{ display: "none" }}>
      {coaches.length > 0 ? (
        <div className="table-container">
          <table className="table table-hover">
            <tbody>
              {coaches.map((manager, index) => (
                <tr key={"manager_" + index}>
                  <td className="manager_table_item" style={tableStyle}>
                    <div className="profile_image_container">
                      {manager.photoPath ? (
                        <AsyncImage
                          src={API.url + "api/user/download/" + manager.id}
                          className="profile_photo m-1"
                          onClick={enlargeImage}
                        />
                      ) : (
                        <img
                          src={manager.photoSrc}
                          className="profile_photo"
                          onClick={enlargeImage}
                          alt=""
                        />
                      )}
                    </div>
                  </td>
                  <td className="club_table_item" style={tableStyle}>
                    <h6
                      style={primaryColorText}
                      className="club_member_name mb-0"
                    >
                      {manager.lastName + " " + manager.firstName}
                    </h6>
                  </td>
                  <td className="club_table_item" style={tableStyle}>
                    <h6
                      style={primaryColorText}
                      className="club_member_email mb-0"
                    >
                      {manager.email}
                    </h6>
                  </td>
                  <td className="club_table_item" style={tableStyle}>
                    {selectedCoach?.id !== manager.id && (
                      <button
                        className="btn btn-primary m-1"
                        style={primaryColorBg}
                        onClick={(e) => selectCoach(e, manager)}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <h4 style={primaryColorText} className="empty_list_text">
          {t("no_coaches")}
        </h4>
      )}
    </div>
  );
};

export default CoachSelectForm;
